import { NativeModules, Platform } from 'react-native';
import { ASSAABLOY, DORMAKABA, SALTO, CMSPath } from '../../config/Constant';
import AsyncStorage from '@react-native-async-storage/async-storage';

export const initializeDoorKey = (doorKeyType) => {
    
    return async (dispatch, getState) => {
        
        const { AssaAbloyPlugin, DormakabaPlugin, SaltoPlugin } = NativeModules;
        const { currentGuestDetails } = getState().guestDetailsSlice;
        const { isLoggedIn, loggedInRoomNumber, fcmToken } = getState().appConfigSlice;

        const sessionToken = await AsyncStorage.getItem("sessionToken")

        console.log("in initializing door key: ",doorKeyType, fcmToken);

        if(!isLoggedIn){
            console.log("not logged in, not initializing door key");
            return;
        }

        if (fcmToken) {
            if (doorKeyType == ASSAABLOY && AssaAbloyPlugin) {
                AssaAbloyPlugin.initializePlugin(CMSPath, sessionToken, currentGuestDetails.reservationNumber, fcmToken, (status) => console.log("initialize door key status: ", status));
                return;
            }
        }

        if (doorKeyType == DORMAKABA && DormakabaPlugin) {
            DormakabaPlugin.initializePlugin(CMSPath, sessionToken, currentGuestDetails.reservationNumber, loggedInRoomNumber, (status) => console.log("initialize door key status: ", status));
            return;
        }
        
        if (doorKeyType == SALTO && SaltoPlugin) {
            SaltoPlugin.initializePlugin(CMSPath, sessionToken, currentGuestDetails.reservationNumber, (status) => console.log("initialize door key status: ", status));
            return;
        }
    }
}